<template>
    <div class="float-left">
        <i
            class="fa fa-info-circle fa-lg icon-button"
            title="Dados da Despesa"
            @click.stop="abrirModal()"
        >
        </i>
        <b-modal
            id="modalPrestacaoFinal"
            size="xl"
            v-model="mostrarModal"
            no-close-on-backdrop
            no-enforce-focus
            @close="verificarFechar()"
        >
            <div slot="modal-title">Dados da Despesa</div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <div>
                <b-row>
                    <b-col sm="12" md="2">
                        <b-form-group>
                            <label for="idPrestacaoContasMensal">
                                Prestação Mensal
                            </label>
                            <b-input-group>
                                <b-form-input
                                    id="idPrestacaoContasMensal"
                                    type="text"
                                    v-model="prestacaoContaMensal.idPrestacaoContasMensal"
                                    disabled>
                                </b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="2">
                        <b-form-group>
                            <label for="dtCompetencia">Competência</label>
                            <b-input-group>
                                <b-form-input
                                    id="idPrestacaoContasMensal"
                                    type="text"
                                    v-model="prestacaoContaMensal.dtCompetencia"
                                    disabled
                                ></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="2">
                        <b-form-group>
                            <label for="dtPrestacao">Data Prestação</label>
                            <b-input-group>
                                <b-form-input
                                    id="dtPrestacao"
                                    type="text"
                                    v-model="prestacaoContaMensal.dtPrestacao"
                                    disabled
                                ></b-form-input>
                            </b-input-group>
                        </b-form-group>
                    </b-col>

                    <b-col sm="12" md="2">
                        <b-form-group>
                            <label>Total Despesas</label>
                            <b-input-group>
                                <money
                                    id="nuTotalGasto"
                                    v-model="nuTotalGasto"
                                    v-bind="money"
                                    class="form-control text-right"
                                    disabled
                                ></money>
                            </b-input-group>
                        </b-form-group>
                    </b-col>

                    <b-col sm="12" md="2">
                        <b-form-group>
                            <label for="nuTotalRendimentos">
                                Total Rendimentos
                            </label>
                            <b-input-group>
                                <money
                                    id="nuTotalRendimentos"
                                    v-model="nuTotalRendimentos"
                                    v-bind="money"
                                    class="form-control text-right"
                                    disabled
                                ></money>
                            </b-input-group>
                        </b-form-group>
                    </b-col>

                    <b-col sm="12" md="2">
                        <b-form-group>
                            <label for="nuReceitasDiversas">
                                Receitas Diversas
                            </label>
                            <b-input-group>
                                <money
                                    id="nuReceitasDiversas"
                                    v-model="nuReceitasDiversas"
                                    v-bind="money"
                                    class="form-control text-right"
                                    disabled
                                ></money>
                            </b-input-group>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row>
                    <b-col sm="12" md="12">
                        <b-card no-body>
                            <b-card-header>
                                <span class="h5"> Lançamentos </span>
                            </b-card-header>
                            <b-card-body>
                                <app-tabela
                                    idTabela="tblPrestacaoFinal"
                                    :itens="prestacoesContasFinal"
                                    :campos="campos"
                                    :itensPorPagina="itensPorPagina"
                                    :bordered="false"
                                    :small="false"
                                >
                                    <template slot="botoes">
                                        <b-button-group class="float-right">
                                            <btn-inserir-prestacao-conta-final-lancamento
                                                :convenio="convenio"
                                                :desativarBotao="false"
                                                :prestacaoMensal="prestacaoMensal"
                                                class="mr-2"
                                                v-if="$temAcessoView('CONV-MEN-DES-01')"
                                                @ocorreuAlteracao="ocorreuAlteracao()"
                                                @atualizarLista="atualizarLista()"
                                            >
                                            </btn-inserir-prestacao-conta-final-lancamento>
                                        </b-button-group>
                                    </template>
                                    <template slot="acoes" slot-scope="data">
                                        <span
                                            class="
                                                text-secondary
                                                float-left
                                                mr-1
                                            "
                                            v-if="
                                                $temAcessoView(
                                                    'CONV-MEN-DES-03'
                                                )
                                            "
                                        >
                                            <b-button-group class="float-right">
                                                <btn-glosar
                                                    :convenio="convenio"
                                                    :prestacaoContasFinalLancamento="
                                                        data
                                                    "
                                                    @atualizarLista="
                                                        atualizarLista()
                                                    "
                                                    @ocorreuAlteracao="
                                                        ocorreuAlteracao()
                                                    "
                                                    @fecharModal="fecharModal()"
                                                    @obterPrestacaoMensal="
                                                        obterPrestacaoMensal()
                                                    "
                                                    @abrirModal="abrirModal()"
                                                >
                                                </btn-glosar>
                                            </b-button-group>
                                        </span>
                                        <span
                                            class="text-warning float-left mr-1"
                                            v-if="
                                                $temAcessoView(
                                                    'CONV-MEN-DES-03'
                                                )
                                            "
                                        >
                                            <b-button-group class="float-right">
                                                <btn-resetar
                                                    :convenio="convenio"
                                                    :prestacaoContasFinalLancamento="
                                                        data
                                                    "
                                                    @atualizarLista="
                                                        atualizarLista()
                                                    "
                                                    @ocorreuAlteracao="
                                                        ocorreuAlteracao()
                                                    "
                                                >
                                                </btn-resetar>
                                            </b-button-group>
                                        </span>
                                        <span
                                            class="text-primary float-left mr-1"
                                            v-if="
                                                $temAcessoView(
                                                    'CONV-MEN-DES-DOC-00'
                                                )
                                            "
                                        >
                                            <b-button-group class="float-right">
                                                <btn-conferir
                                                    :convenio="convenio"
                                                    :prestacaoContasFinalLancamento="
                                                        data
                                                    "
                                                    @atualizarLista="
                                                        atualizarLista()
                                                    "
                                                    @ocorreuAlteracao="
                                                        ocorreuAlteracao()
                                                    "
                                                >
                                                </btn-conferir>
                                            </b-button-group>
                                        </span>
                                        <span
                                            class="text-primary float-left mr-1"
                                            v-if="
                                                $temAcessoView(
                                                    'CONV-MEN-DES-DOC-00'
                                                )
                                            "
                                        >
                                            <b-button-group class="float-right">
                                                <btn-atualizar-prestacao-contas-final-lancamento
                                                    :convenio="convenio"
                                                    :prestacaoMensal="
                                                        prestacaoMensal
                                                    "
                                                    :prestacaoContasFinalLancamento="
                                                        data
                                                    "
                                                    :desativarBotao="false"
                                                    class="mr-2"
                                                    v-if="
                                                        $temAcessoView(
                                                            'CONV-MEN-DES-01'
                                                        )
                                                    "
                                                    @atualizarLista="
                                                        atualizarLista()
                                                    "
                                                    @ocorreuAlteracao="
                                                        ocorreuAlteracao()
                                                    "
                                                >
                                                </btn-atualizar-prestacao-contas-final-lancamento>
                                            </b-button-group>
                                        </span>
                                        <span
                                            class="text-info float-left mr-1"
                                            v-if="
                                                $temAcessoView(
                                                    'CONV-MEN-DES-DOC-00'
                                                )
                                            "
                                        >
                                            <b-button-group class="float-right">
                                                <prestacao-contas-final-documentos
                                                    :prestacaoContasFinal="data"
                                                    class="mr-2"
                                                >
                                                </prestacao-contas-final-documentos>
                                            </b-button-group>
                                        </span>
                                        <span
                                            class="text-primary float-left mr-1"
                                            v-if="
                                                $temAcessoView(
                                                    'CONV-MEN-DES-DOC-00'
                                                )
                                            "
                                        >
                                            <b-button-group class="float-right">
                                                <btn-excluir-prestacao-contas-final-lancamento
                                                    :convenio="convenio"
                                                    v-if="data.codSituacao == 0"
                                                    :prestacaoContasFinalLancamento="
                                                        data
                                                    "
                                                    @atualizarLista="
                                                        atualizarLista()
                                                    "
                                                    @ocorreuAlteracao="
                                                        ocorreuAlteracao()
                                                    "
                                                >
                                                </btn-excluir-prestacao-contas-final-lancamento>
                                            </b-button-group>
                                        </span>
                                    </template>
                                    <template slot="nuValor" slot-scope="data">
                                        <p class="text-right m-0">
                                            {{ data.nuValor | currency }}
                                        </p>
                                    </template>
                                    <template
                                        slot="dtEmissao"
                                        slot-scope="data"
                                    >
                                        <p class="text-left m-0">
                                            {{
                                                data.dtEmissao
                                                    ? $moment(
                                                          data.dtEmissao
                                                      ).format('DD/MM/YYYY')
                                                    : null
                                            }}
                                        </p>
                                    </template>
                                    <template
                                        slot="dtPagamento"
                                        slot-scope="data"
                                    >
                                        <p class="text-left m-0">
                                            {{
                                                data.dtPagamento != null
                                                    ? $moment(
                                                          data.dtPagamento
                                                      ).format('DD/MM/YYYY')
                                                    : null
                                            }}
                                        </p>
                                    </template>
                                    <template slot="situacao" slot-scope="data">
                                        <app-status
                                            :status="
                                                data.situacao.toUpperCase()
                                            "
                                        ></app-status>
                                    </template>
                                </app-tabela>
                            </b-card-body>
                        </b-card>
                    </b-col>
                </b-row>
            </div>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="verificarFechar()"
                    >Fechar</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import { required, minValue } from 'vuelidate/lib/validators'
import ConveniosServicos from '../ConveniosServicos'
import BtnInserirPrestacaoContaFinalLancamento from './prestacaoContasFinalLancamento/BtnInserirPrestacaoContaFinalLancamento.vue'
import BtnAtualizarPrestacaoContasFinalLancamento from './prestacaoContasFinalLancamento/BtnAtualizarPrestacaoContasFinalLancamento.vue'
import BtnExcluirPrestacaoContasFinalLancamento from './prestacaoContasFinalLancamento/BtnExcluirPrestacaoContasFinalLancamento.vue'
import BtnGlosar from './prestacaoContasFinalLancamento/BtnGlosar.vue'
import BtnConferir from './prestacaoContasFinalLancamento/BtnConferir.vue'
import BtnResetar from './prestacaoContasFinalLancamento/BtnResetar.vue'
import PrestacaoContasFinalDocumentos from './PrestacaoContasFinalDocumentos.vue'

export default {
    components: {
        BtnAtualizarPrestacaoContasFinalLancamento,
        BtnInserirPrestacaoContaFinalLancamento,
        BtnExcluirPrestacaoContasFinalLancamento,
        BtnGlosar,
        BtnConferir,
        BtnResetar,
        PrestacaoContasFinalDocumentos
    },

    props: {
        convenio: Object,
        prestacaoMensal: Number,
        nuReceitasDiversas: Number,
        nuTotalGasto: Number,
        nuTotalRendimentos: Number
    },

    validations: {
        valor: {
            required,
            minValue: minValue(0.01)
        }
    },

    data() {
        return {
            habilitaCampos: true,
            tabIndex: 0,
            valor: 0,
            mostrarModal: false,
            houveAlteracao: false,

            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            erros: [],
            itensPorPagina: 5,
            prestacaoContaMensal: {},
            prestacoesContasFinal: [],
            campos: [
                {
                    key: 'tipoPrestacaoContas',
                    label: 'Tipo',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'acaoConvenio.descricao',
                    label: 'Ação',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'naturezaDespesa.descricaoCompleta',
                    label: 'Natureza',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'dtEmissao',
                    label: 'Emissão',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'vcFavorecido',
                    label: 'Favorecido',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'vcDocumento',
                    label: 'Documento',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'nuValor',
                    label: 'Valor',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'dtPagamento',
                    label: 'Pagamento',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'lancamentoBancario',
                    label: 'Lançamento Bancário',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'situacao',
                    label: 'Situação',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'acoes',
                    label: ''
                }
            ],
            prestacaoContasFinalLancamento: {
                codSituacao: 1,
                codTipoPrestacaoContas: 0,
                dtEmissao: null,
                dtPagamento: null,
                idAcaoConvenio: 0,
                idNaturezaDespesa: 0,
                idPrestacaoContasFinal: 0,
                idPrestacaoContasMensal: 0,
                nuConfins: 0,
                nuCsll: 0,
                nuInss: 0,
                nuIr: 0,
                nuIss: 0,
                nuPis: 0,
                nuValor: 0,
                situacao: null,
                tipoPrestacaoContas: null,
                vcDoctoPag: null,
                vcDocumento: null,
                vcFavorecido: null,
                vcObservacao: null
            }
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
            this.obterPrestacaoMensal()
        },

        fecharModal() {
            this.mostrarModal = false
        },

        verificarFechar() {
            if (this.houveAlteracao == true) {
                this.fecharModal()
                this.$emit('obterConvenio')
                this.houveAlteracao = false
            } else {
                this.fecharModal()
            }
        },

        ocorreuAlteracao() {
            this.houveAlteracao = true
        },

        voltar() {
            this.$router.push({
                name: 'Convenios_Detalhar',
                params: {
                    convenioId: this.$route.params.convenioId
                }
            })
        },

        atualizarLista() {
            this.$store.dispatch('addRequest')
            ConveniosServicos.obterPorId(this.$route.params.convenioId).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.prestacaoContaMensal =
                                response.data.prestacoesContasMensal
                            this.obterPrestacaoMensal()
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        obterPrestacaoMensal() {
            if (this.prestacaoMensal > 0) {
                this.$store.dispatch('addRequest')
                ConveniosServicos.obterPrestacaoContaMensal(
                    this.prestacaoMensal
                ).then((response) => {
                    if (response) {
                        if (response.success) {
                            this.prestacaoContaMensal = response.data
                            this.prestacaoContaMensal.dtCompetencia =
                                this.$moment(
                                    this.prestacaoContaMensal.dtCompetencia,
                                    'YYYY-MM-DD'
                                ).format('MM/YYYY')
                            this.prestacaoContaMensal.dtPrestacao =
                                this.$moment(
                                    this.prestacaoContaMensal.dtPrestacao,
                                    'YYYY-MM-DD'
                                ).format('DD/MM/YYYY')
                            this.prestacoesContasFinal =
                                response.data.prestacoesContasFinal
                        } else {
                            this.erros = response.errors
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            }
        }
    },

    watch: {
        convenio() {
            if (this.convenio) {
                this.prestacoesContasFinal = this.convenio.prestacoesContasFinal
                this.convenio = this.convenio
            }
        }
    }
}
</script>
